<form [formGroup]="form">
  <ng-select
    #locationSelect
    formControlName="locations"
    [items]="locations"
    [multiple]="true"
    [searchWhileComposing]="true"
    (clear)="onSelectedLocationsChange([])"
    [closeOnSelect]="false"
    [hideSelected]="true"
    [clearSearchOnAdd]="true"
    [placeholder]="'campaignDetails.locations' | translate"
    (change)="onSelectedLocationsChange($event)"
  >
    <ng-template ng-label-tmp let-item="item">
      <ng-container>
        <span
          [ngbTooltip]="shouldShowAvailabilityTooltip(item) ? tooltipAvailability : null"
          placement="bottom"
          [container]="'body'"
          [ngClass]="
            'badge ' +
            badgeService.getBadgeForLocationPartnerAvailability(
              getAvailabilityStatusFromLocationPartnerAvailability(item)
            )
          "
        >
          <i
            (click)="removeLocationPartner(item, $event)"
            class="icofont icofont-close me-1 cursor-pointer"
          ></i>
          <i
            *ngIf="
              badgeService.getIconForLocationPartnerAvailability(
                getAvailabilityStatusFromLocationPartnerAvailability(item)
              ) as availabilityIcon
            "
            class="icofont me-1"
            [ngClass]="availabilityIcon"
          ></i>
          {{ item }}

          <i
            *ngIf="canShowAllAvailablePeriods(item)"
            (click)="showAllAvailablePeriods(item, $event)"
            class="icofont icofont-info-circle ms-1 cursor-pointer"
          ></i>

          <i
            *ngIf="
              canEditAvailability(item)
            "
            (click)="showModalUpdateAvailability(item, $event)"
            class="icofont icofont-edit ms-1 cursor-pointer"
          ></i>
        </span>

        <ng-template #tooltipAvailability>
          <div
            *ngIf="
              isOperationalAvailability(
                getAvailabilityStatusFromLocationPartnerAvailability(item)
              );
              else dates
            "
          >
            {{
              badgeService.getLabelKeyForLocationPartnerAvailability(
                getAvailabilityStatusFromLocationPartnerAvailability(item)
              ) | translate
            }}
          </div>
          <ng-template #dates>
            {{ "campaignDetails.availability.title" | translate }}
            <div *ngIf="getLocationAvailabilityDates(item) as dates">
              <div *ngFor="let item of dates.slice(0, 2)">
                {{ "campaignDetails.availability.from" | translate }}
                {{ item.startDate | localizedDate }}
                {{ "campaignDetails.availability.to" | translate }}
                {{ item.endDate | localizedDate }}
              </div>
              <div *ngIf="dates.length > 2" class="m-t-2">
                {{ "updateAvailability.click" | translate }}
                <i class="icofont icofont-info-circle ms-1 cursor-pointer"></i>
                {{ "updateAvailability.otherPeriods" | translate }}
              </div>
            </div>
          </ng-template>
        </ng-template>
      </ng-container>
    </ng-template>
  </ng-select>
</form>
